import { render, staticRenderFns } from "./im.vue?vue&type=template&id=7166add7&scoped=true"
import script from "./im.vue?vue&type=script&lang=ts"
export * from "./im.vue?vue&type=script&lang=ts"
import style0 from "./im.vue?vue&type=style&index=0&id=7166add7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166add7",
  null
  
)

export default component.exports